import { ChangeEvent, FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { useFormik } from "formik";
import {
  Checkbox,
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  StringInput,
} from "~/OnboardingApp/components";
import { usePartner } from "~/OnboardingApp/hooks";
import { Values } from "../PhonePage";
import { formatPhone } from "../utils";

interface Props {
  formik: ReturnType<typeof useFormik<Values>>;
}

export const PhoneForm: FC<Props> = ({ formik }) => {
  const { t } = useTranslation();
  const { isPartner } = usePartner();
  const { resetForm, validateForm } = formik;
  const { international, phone } = formik.values;

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const oldValue = phone || "";
    const newValue = formatPhone({ value, oldValue });

    formik.setFieldValue("phone", newValue);
  };

  const promptCopy = isPartner
    ? t("onboarding.phonePage.description.partner")
    : t("onboarding.phonePage.description.default");

  useEffect(() => {
    if (international) {
      resetForm({
        values: {
          phone: "",
          international: true,
        },
      });
      validateForm();
    }
  }, [international, resetForm, validateForm]);

  const placeholder = international
    ? ""
    : t("onboarding.phonePage.placeholder");

  return (
    <FormContainer formik={formik}>
      <QuestionContainer>
        <Prompt
          description={promptCopy}
          question={t("onboarding.phonePage.question")}
        />

        <Flex direction="column" gap={1}>
          <StringInput
            id="phone"
            placeholder={placeholder}
            onChange={handlePhoneChange}
            isDisabled={international}
          />
        </Flex>
        <Checkbox name="international">
          <Text variant="th-body2">
            {t("onboarding.phonePage.international")}
          </Text>
        </Checkbox>
      </QuestionContainer>

      <NextButton isLast={isPartner} />
    </FormContainer>
  );
};
